import { createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerInitialState, basedDataReducer } from 'redux/base-reducer';

import { ICompanyType } from '../types/company-type.types';

interface CompanyTypeInitialState extends BaseDataReducerInitialState<ICompanyType> {}

const { initialState, AC, reducer, thunks } = basedDataReducer<ICompanyType, CompanyTypeInitialState>(
  'company-type-base',
);

const companyTypeInitialState: CompanyTypeInitialState = {
  ...initialState,
  perPage: 15,
};

export const companyType = createSlice({
  name: 'companyType',
  initialState: companyTypeInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as CompanyTypeInitialState, action);
    });
  },
});
export const CompanyTypeAC = AC;

export const setCompanyTypeCurrentPage = AC.setCurrentPage;
export const onCompanyTypeSort = thunks.onSort;
export const onCompanyTypeFilter = thunks.onFilter;
export const clearCompanyTypeFilters = AC.clearFilters;
